import { Navigate, useLocation } from "react-router-dom";

const SPOUSE_ALLOWED_PATHS = ["/spouse-confirm"];

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) {
    // Remember product intent so login can route back to the product entry
    // instead of the default onboarding destination.
    if (location.pathname.startsWith("/investing")) {
      localStorage.setItem("postLoginRedirect", "/investing");
    }
    return <Navigate to="/login" replace />;
  }

  const isSpouseSession = localStorage.getItem("isSpouseSession") === "true";
  if (isSpouseSession && !SPOUSE_ALLOWED_PATHS.includes(location.pathname)) {
    return <Navigate to="/spouse-confirm" replace />;
  }

  return children;
};

export default ProtectedRoute;
